import * as HeroIconsOutline from '@heroicons/react/outline';
import React, { useEffect, useMemo, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import ReactSelect, { components } from 'react-select';
import { Error } from '../Error';
import { Label } from '../Label';
import { colors } from '../style/colors';
import { appendClassProps } from '../util';
export const Select = ({ disabled = false, searchable = false, clearable = true, loading = false, label, value, onChangeValue, options: menuItems, errorMessage, revealErrorMessage, tooltip, className, hideErrorSection, leftIcon, placeholder, autoFocus }) => {
    const [dirty, setDirty] = useState(false);
    const [_placeholder, setPlaceholder] = useState(placeholder);
    useEffect(() => {
        setPlaceholder(placeholder);
    }, [placeholder]);
    let LeftIcon;
    if (leftIcon)
        LeftIcon = HeroIconsOutline[leftIcon];
    const showErrorMessage = errorMessage && (revealErrorMessage || dirty) ? true : false;
    const options = useMemo(() => menuItems
        .filter((i) => i.id)
        .map((item) => ({
        value: item.id,
        label: item.label
    })), [menuItems]);
    const handleChange = (newValue) => {
        setDirty(true);
        onChangeValue && onChangeValue(newValue?.value);
    };
    const handleBlur = () => {
        setDirty(true);
    };
    const ValueContainer = ({ children, ...props }) => (React.createElement(components.ValueContainer, { ...props },
        React.createElement("div", { className: "flex flex-row h-full items-center" },
            LeftIcon && (React.createElement(LeftIcon, { className: "h-6 text-gray-400", "data-testid": "left-icon" })),
            children)));
    const DropdownIndicator = (props) => (React.createElement(components.DropdownIndicator, { ...props },
        React.createElement(HeroIconsOutline.ChevronDownIcon, { className: "h-5 w-5 lg:h-6 lg:w-6" })));
    const styles = {
        input: (base) => ({
            ...base,
            padding: '0',
            margin: '0'
        }),
        control: (base) => ({
            ...base,
            height: '34px',
            minHeight: '34px',
            boxShadow: 'none',
            backgroundColor: colors.white,
            color: colors.gray['400'],
            borderRadius: '2px'
        }),
        valueContainer: (base) => ({
            ...base,
            padding: '0 0.25rem'
        }),
        singleValue: (base) => ({
            ...base,
            color: colors.blue['800']
        }),
        dropdownIndicator: (base) => ({
            ...base,
            height: '34px',
            alignItems: 'center',
            padding: '0 0.25rem 0 0.25rem'
        }),
        clearIndicator: (base) => ({
            ...base,
            height: '34px',
            alignItems: 'center',
            padding: '0 0.25rem 0 0.25rem'
        }),
        indicatorSeparator: () => ({
            display: 'none'
        }),
        menu: (base) => ({
            ...base,
            color: colors.blue['800']
        })
    };
    const theme = (theme) => ({
        ...theme,
        colors: {
            ...theme.colors,
            primary: colors.blue['800'],
            primary75: colors.blue['600'],
            primary50: colors.blue['400'],
            primary25: colors.blue['200'],
            danger: colors.red['500'],
            dangerLight: colors.red['300'],
            neutral0: colors.white,
            neutral5: colors.gray['50'],
            neutral10: colors.gray['100'],
            neutral20: colors.gray['200'],
            neutral30: colors.gray['300'],
            neutral40: colors.gray['400'],
            neutral50: colors.gray['500'],
            neutral60: colors.gray['600'],
            neutral70: colors.gray['700'],
            neutral80: colors.gray['800'],
            neutral90: colors.gray['900']
        }
    });
    return (React.createElement("div", { "data-testid": "select", className: `${className?.includes('absolute') ? '' : 'relative'}${disabled ? ' opacity-75 cursor-not-allowed' : ''}${appendClassProps(className)}` },
        label && (React.createElement(Label, { dataTestId: "label", tooltip: tooltip }, label)),
        loading ? (React.createElement(Skeleton, { width: '100%', height: '34px' })) : (React.createElement(ReactSelect, { isDisabled: disabled, value: options.find(function (option) {
                return option.value === value;
            }), isSearchable: searchable, isClearable: clearable, options: options, styles: styles, theme: theme, onChange: handleChange, components: {
                ValueContainer,
                DropdownIndicator
            }, onBlur: handleBlur, placeholder: _placeholder, onFocus: () => setPlaceholder(''), autoFocus: autoFocus, menuPlacement: "auto" })),
        !hideErrorSection && (React.createElement(Error, { errorMessage: errorMessage, showErrorMessage: showErrorMessage }))));
};
export * from './index.types';
//# sourceMappingURL=index.js.map